<template lang="pug">
  .card-container.program-card.column.m-bottom-2
    .placeholder.image
    .container.item-1.column
      .placeholder.title.m-top-2.m-bottom-auto
      .placeholder.ages.m-top-auto
      .row.middle.m-top-2
        .placeholder.avatar.m-right-2
        .placeholder.author
</template>

<script>

export default {

}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.program-card{
  margin: 0;
  height: 370px;
  .container{
    padding: 10px;
  }
}
.placeholder{
  background-color: $light-gray;
  &.image{
    height: 160px;
  }
  &.title{
    height: 25px;
    width: 180px;
  }
  &.ages{
    height: 20px;
    width: 90%;
  }
  &.avatar{
    height: 32px;
    width: 32px;
    border-radius: 50%;
  }
  &.author{
    height: 14px;
    width: 90px;
  }
}
</style>
